import { BlockUsersService } from '~/settings/service/BlockUsersService';

export class BlockUsersBiz {
  static fallbackThumbnailImage = './css/img/thumb_default.png';

  static getBlockContactThumbnail(item) {
    return `/p/photo/v2/photos?contactType=CONTACT&uuid=${item.worksAtContactNo}&photoSize=ff210&photoHash=${item.photoHash}`;
  }

  static async getBlickedContactList() {
    const [error, result] = await BlockUsersService.requestForBlockContacts();
    if (error) {
      console.error('Failed to get blocked contacts');
      return [];
    } else {
      return result;
    }
  }

  static async unblockContacts(contactNo) {
    const result =
      await BlockUsersService.unblockingExternalContacts(contactNo);
    return !!result;
  }
}
